import { jwtTokenParse } from '@kocsistem/oneframe-react-bundle';
import { Popper } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fade from '@material-ui/core/Fade';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ImportExportIcon from '@material-ui/icons/ImportExport';
// import LanguageIcon from '@material-ui/icons/Language';
import PersonIcon from '@material-ui/icons/Person';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useState } from 'react';
import { isFirefox, isChrome, isEdge } from 'react-device-detect';
// import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { useDebouncedCallback } from 'use-debounce';

import { get, post } from '../../../core/client';
import { LOCAL_STORAGE } from '../../../core/constants';
import { getLocalStorageItem, setLocalStorageItem } from '../../../core/utility';
import { useAppSelector } from '../../../store';
// import { getLocalizationWords } from '../../../store/features/localization/localizationSlice';
import Spinner from '../../ui/spinner';

// let scrollingTimeout: any = null;

const initialStatus: any = {
    pageIndex: 0,
    pageSize: 10,
};

const Header = () => {
    const history: any = useHistory();
    // const dispatch = useDispatch();
    const { userInfo } = useAppSelector(state => state.users.info);
    const { words } = useAppSelector(state => state.localization);
    const [open, setOpen] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    // const [isScroll, setIsScroll] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isChangeUserLoading, setIsChangeUserLoading] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);

    const [searcInputParam, setSearcInputParam] = useState<any>('');
    const [proxyUser, setProxyUser] = useState<any>([]);
    // // const [language, setLanguage] = useState<any>({ culture: 'tr-TR', name: 'Türkçe' });
    const [proxyUserId, setProxyUserId] = useState<any>(null);
    // const [pageStatus, setPageStatus] = useState<any>(initialStatus);
    // const languageCulture = getLocalStorageItem('SelectedLanguage');
    const { departments } = useAppSelector(state => state.moments.aside);
    const { userClaims } = useAppSelector(state => state.users);
    const handleChangeUser = async () => {
        const endpoint = `accounts/adminUserChangeCallBack?childUserId=${proxyUserId}`;
        setIsChangeUserLoading(true);
        await post<any>(endpoint, '', '').then(res => {
            if (res.isSuccessful) {
                const oldUserValues: any = {
                    myAccessToken: getLocalStorageItem(LOCAL_STORAGE.ACCESS_TOKEN),
                    myRefreshToken: getLocalStorageItem(LOCAL_STORAGE.REFRESH_TOKEN),
                    myUserEmail: getLocalStorageItem(LOCAL_STORAGE.USER_EMAIL),
                    myPanelToken: getLocalStorageItem(LOCAL_STORAGE.Encrypted_Panel_Token),
                    myUserFullName: getLocalStorageItem(LOCAL_STORAGE.USER_FULLNAME),
                    myUserRoleClaims: getLocalStorageItem(LOCAL_STORAGE.USER_ROLE_CLAIMS),
                    myUserId: getLocalStorageItem(LOCAL_STORAGE.USER_ID),
                    myExpiredTime: getLocalStorageItem(LOCAL_STORAGE.EXPIRED_TIME),
                };
                setLocalStorageItem('oldUserValues', oldUserValues);
                const sanitizedBase64 = res.result?.token.split('.')[1].replaceAll('-', '+').replaceAll('_', '/');
                const splittedToken = res.result?.token.split('.');
                const sanitizedToken = splittedToken[0] + '.' + sanitizedBase64 + '.' + splittedToken[2];
                const token: any = jwtTokenParse(sanitizedToken);

                setLocalStorageItem(LOCAL_STORAGE.REFRESH_TOKEN, res.result?.refreshToken);
                setLocalStorageItem(LOCAL_STORAGE.ACCESS_TOKEN, res.result?.token);
                setLocalStorageItem(LOCAL_STORAGE.USER_EMAIL, res.result?.claims[0].name);
                setLocalStorageItem(LOCAL_STORAGE.USER_ID, res.result?.claims[8].name);
                setLocalStorageItem(LOCAL_STORAGE.EXPIRED_TIME, token.exp);
                setLocalStorageItem(LOCAL_STORAGE.USER_FULLNAME, res.result?.claims[3].name);
                setLocalStorageItem(LOCAL_STORAGE.Encrypted_Panel_Token, res.result?.encryptedToken);
                setLocalStorageItem(LOCAL_STORAGE.USER_ROLE_CLAIMS, res.result?.claims);

                window.location.reload();
            }
        });
        setIsChangeUserLoading(false);
        setOpen(false);
    };

    const oldUserValues = getLocalStorageItem('oldUserValues');
    const closeProxyUser = () => {
        setLocalStorageItem(LOCAL_STORAGE.REFRESH_TOKEN, oldUserValues.myRefreshToken);
        setLocalStorageItem(LOCAL_STORAGE.ACCESS_TOKEN, oldUserValues.myAccessToken);
        setLocalStorageItem(LOCAL_STORAGE.USER_EMAIL, oldUserValues.myUserEmail);
        setLocalStorageItem(LOCAL_STORAGE.USER_ID, oldUserValues.myUserId);
        setLocalStorageItem(LOCAL_STORAGE.EXPIRED_TIME, oldUserValues.myExpiredTime);
        setLocalStorageItem(LOCAL_STORAGE.USER_FULLNAME, oldUserValues.myUserFullName);
        setLocalStorageItem(LOCAL_STORAGE.Encrypted_Panel_Token, oldUserValues.myPanelToken);
        setLocalStorageItem(LOCAL_STORAGE.USER_ROLE_CLAIMS, oldUserValues.myUserRoleClaims);
        setLocalStorageItem('oldUserValues', '');
        window.location.reload();
    };

    const getProxyUser = async (pageIndex, pageSize) => {
        setIsLoading(true);
        if (userClaims?.items?.some(x => x.value === 'User_Change_Login') && searcInputParam.length > 2) {
            await get<any>(`/users/searchProxyUser?PageIndex=${pageIndex}&PageSize=${pageSize}&Search=${searcInputParam}`).then(res => {
                const options = [];
                for (let i = 0; i < res?.result?.result?.items?.length; i++) {
                    const option = res?.result?.result?.items[i];
                    options.push({
                        label: option.name + ' ' + option.surname,
                        position: option.position + '@' + option.departmentName,
                        photo: option.photo,
                        userId: option.id,
                    });
                }

                setProxyUser(options);
            });
        }
        setIsLoading(false);
    };

    useEffect(() => {
        debounceSearch(initialStatus.pageIndex, initialStatus.pageSize);
    }, [initialStatus.pageIndex, initialStatus.pageSize, searcInputParam]);

    // useEffect(() => {
    //     dispatch(getLocalizationWords());
    // }, [language]);

    // const setPagination = (val: any) => {
    //     setIsScroll(val);
    // };

    // const checkPagination = (event: any) => {
    //     const promise = new Promise<boolean>(resolve => {
    //         const x = Math.ceil(event.target.scrollHeight - event.target.scrollTop);
    //         const y = event.target.clientHeight;
    //         if (x === y) {
    //             event.target.scrollTop -= 10;
    //             resolve(true);
    //         }
    //     });
    //     return promise;
    // };

    // const userScrolling = () => {
    //     if (scrollingTimeout !== null) {
    //         clearTimeout(scrollingTimeout);
    //     }
    //     scrollingTimeout = setTimeout(function () {
    //         if (isScroll) {
    //             setPageStatus({
    //                 ...pageStatus,
    //                 pageIndex: searcInputParam.length > 1 ? (pageStatus.pageIndex = 0) : pageStatus.pageIndex + 1,
    //             });
    //         }
    //     }, 200);
    // };

    const [debounceSearch] = useDebouncedCallback((pageIndex: any, pageSize: any) => getProxyUser(pageIndex, pageSize), 400);
    // const [debounceFuncScroll] = useDebouncedCallback((value: any) => setPagination(value), 250);

    // const handleScroll = (event: any) => {
    //     return checkPagination(event).then(res => {
    //         if (res) {
    //             debounceFuncScroll(res);
    //             userScrolling();
    //         }
    //     });
    // };

    const setInputChangeValue = (event, newInputValue) => {
        setSearcInputParam(newInputValue);
        if (newInputValue.length > 0) {
            setShowModal(true);
        }
    };

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCloseModal = () => {
        setOpen(false);
    };

    const handleCloseMenu = () => {
        setOpen(true);
        setAnchorEl(null);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    // const handleCloseLanguageMenu = language => {
    //     setLocalStorageItem('SelectedLanguage', {culture:language.culture,languageName:language.name});
    //     setLanguage(language);
    //     setAnchorEl(null);
    // };

    const handleChangeProxy = (e, val) => {
        setProxyUserId(val.userId);
    };

    const CustomPopper = props => {
        return <Popper {...props} className="modal-04 " placement="bottom" />;
    };

    if (departments?.length === 0) {
        return null;
    }

    return (
        <div className={!(isFirefox || isChrome || isEdge) ? 'header-01 show' : 'header-01'}>
            <div className="c-wrapper">
                <a href="/" className="c-item-01">
                    <img src="https://khicindekocvar.blob.core.windows.net/cdn/prod/home-page%20.svg" />
                </a>
                <div className="c-item-02">
                    {userInfo && (
                        <div className="c-item-container">
                            <h5 className="c-item-02-A">
                                {userInfo?.name} {userInfo?.surname}
                            </h5>

                            <div className="c-item-photo">
                                {oldUserValues && (
                                    <a className="c-item-photo-close" href="#!" onClick={closeProxyUser}>
                                        <svg
                                            className="close-icon"
                                            width="30"
                                            height="30"
                                            viewBox="0 0 35 35"
                                            fill="#00a3ff"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M17.4998 32.0834C25.554 32.0834 32.0832 25.5542 32.0832 17.5001C32.0832 9.44593 25.554 2.91675 17.4998 2.91675C9.44568 2.91675 2.9165 9.44593 2.9165 17.5001C2.9165 25.5542 9.44568 32.0834 17.4998 32.0834Z"
                                                stroke="white"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M21.875 13.125L13.125 21.875"
                                                stroke="white"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M13.125 13.125L21.875 21.875"
                                                stroke="white"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </a>
                                )}
                                <a href="#!" className="c-item-wrapper" onClick={handleClick}>
                                    <img
                                        src={userInfo?.photo ? userInfo.photo : 'https://khicindekocvar.blob.core.windows.net/prod/koc_icon_user.svg'}
                                        alt="avatar"
                                        className="c-item-02-B"
                                    />
                                    <svg className="c-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 9L12 15L18 9" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </a>
                                <Menu
                                    id="simple-menu"
                                    className="c-item-userInfo"
                                    elevation={0}
                                    getContentAnchorEl={null}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={handleClose}>
                                    <a href={userInfo.id ? '/profile?u=' + userInfo.id : '!#'} className="c-item-userInfo">
                                        <MenuItem>
                                            <PersonIcon></PersonIcon>
                                            <span className="c-item-01-A" onClick={handleClose}>
                                                {words && words['WEB.myProfile']}
                                            </span>
                                        </MenuItem>
                                    </a>
                                    {userClaims?.items?.some(x => x.value === 'User_Change_Login') && !oldUserValues && (
                                        <div>
                                            <Modal
                                                aria-labelledby="transition-modal-title"
                                                aria-describedby="transition-modal-description"
                                                className="modal-01"
                                                open={open}
                                                closeAfterTransition
                                                BackdropComponent={Backdrop}
                                                BackdropProps={{
                                                    timeout: 500,
                                                }}
                                                onClose={handleCloseModal}>
                                                <Fade in={open}>
                                                    <div className="modal-12">
                                                        <a className="modal-close-icon" href="#!" onClick={handleCloseModal}>
                                                            <svg
                                                                className="close-icon"
                                                                width="35"
                                                                height="35"
                                                                viewBox="0 0 35 35"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M17.4998 32.0834C25.554 32.0834 32.0832 25.5542 32.0832 17.5001C32.0832 9.44593 25.554 2.91675 17.4998 2.91675C9.44568 2.91675 2.9165 9.44593 2.9165 17.5001C2.9165 25.5542 9.44568 32.0834 17.4998 32.0834Z"
                                                                    stroke="#6C6C7D"
                                                                    strokeWidth="2"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                                <path
                                                                    d="M21.875 13.125L13.125 21.875"
                                                                    stroke="#6C6C7D"
                                                                    strokeWidth="2"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                                <path
                                                                    d="M13.125 13.125L21.875 21.875"
                                                                    stroke="#6C6C7D"
                                                                    strokeWidth="2"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                            </svg>
                                                        </a>
                                                        <h2 className="modal-title">{words && words['WEB.changeUser']}</h2>
                                                        <div className="autocomplete-01">
                                                            <Autocomplete
                                                                closeIcon={<CloseIcon onClick={() => setProxyUser([])} />}
                                                                fullWidth={true}
                                                                id="free-solo-2-demo-person-search"
                                                                open={showModal}
                                                                // ListboxProps={{
                                                                //     onScroll: handleScroll,
                                                                // }}

                                                                ListboxProps={{
                                                                    style: {
                                                                        maxHeight: '250px',
                                                                    },
                                                                }}
                                                                onOpen={handleOpen}
                                                                onClose={() => setShowModal(false)}
                                                                loading={isLoading}
                                                                loadingText={<Spinner />}
                                                                noOptionsText={words && words['WEB.noPersonFounded']}
                                                                PopperComponent={CustomPopper}
                                                                onChange={(e, val) => handleChangeProxy(e, val)}
                                                                renderOption={option => (
                                                                    <>
                                                                        <img
                                                                            className="c-avatar"
                                                                            src={
                                                                                option?.photo
                                                                                    ? option.photo
                                                                                    : 'https://khicindekocvar.blob.core.windows.net/prod/user_icon.png'
                                                                            }
                                                                        />

                                                                        <div className="c-person-wrapper">
                                                                            <span className="c-person-fullname">{option.label} </span>
                                                                            <div className="c-person-position">{option.position}</div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                                onInputChange={setInputChangeValue}
                                                                getOptionLabel={(option: any) => (option && option.label ? option?.label : '')}
                                                                options={proxyUser ? proxyUser : []}
                                                                className="autocomplete-person-team"
                                                                renderInput={params => (
                                                                    <>
                                                                        <TextField
                                                                            {...params}
                                                                            variant="outlined"
                                                                            placeholder={words && words['WEB.seachPeople']}
                                                                            className="autocomplete-textfield"
                                                                            InputProps={{
                                                                                ...params.InputProps,
                                                                                startAdornment: (
                                                                                    <svg
                                                                                        className="autocomplete-search-icon"
                                                                                        width="24"
                                                                                        height="24"
                                                                                        viewBox="0 0 24 24"
                                                                                        fill="none"
                                                                                        xmlns="http://www.w3.org/2000/svg">
                                                                                        <path
                                                                                            d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                                                                                            stroke="#6C6C7D"
                                                                                            strokeWidth="2"
                                                                                            strokeLinecap="round"
                                                                                            strokeLinejoin="round"
                                                                                        />
                                                                                        <path
                                                                                            d="M21.0004 21L16.6504 16.65"
                                                                                            stroke="#6C6C7D"
                                                                                            strokeWidth="2"
                                                                                            strokeLinecap="round"
                                                                                            strokeLinejoin="round"
                                                                                        />
                                                                                    </svg>
                                                                                ),
                                                                            }}
                                                                        />
                                                                    </>
                                                                )}
                                                            />
                                                        </div>
                                                        <p className="modal-text">{words && words['WEB.changeUserText']}</p>
                                                        <div className="modal-button-wrapper">
                                                            <button onClick={handleCloseModal} className="button-modal01">
                                                                {words && words['WEB.giveUp']}
                                                            </button>
                                                            <button onClick={handleChangeUser} className="button-modal02">
                                                                {isChangeUserLoading ? <CircularProgress size={16} /> : words && words['WEB.change']}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Fade>
                                            </Modal>
                                            <button className="c-item-userInfo" onClick={handleCloseMenu}>
                                                <MenuItem>
                                                    <ImportExportIcon />
                                                    <div className="c-item-01-A">{words && words['WEB.changeUser']}</div>
                                                </MenuItem>
                                            </button>
                                        </div>
                                    )}
                                    {userClaims?.items?.some(x => x.value === 'Report_Authority') && (
                                        <div>
                                            <Link to="moment-reports" className="c-item-userInfo" onClick={() => setAnchorEl(null)}>
                                                <MenuItem>
                                                    <FileCopyIcon />
                                                    <div className="c-item-01-A">Raporlar</div>
                                                </MenuItem>
                                            </Link>
                                        </div>
                                    )}
                                    {/* <MenuItem className="c-item-userInfo">
                                        <div className="c-item-01">
                                            <LanguageIcon/>
                                            <a className="c-item-01-A">{ languageCulture.languageName }</a>
                                        </div>

                                        <div className="c-item-02">
                                            {languageInitialData?.map((data, index) => (
                                                <a
                                                    key={'language-items' + index}
                                                    onClick={() => handleCloseLanguageMenu(data)}
                                                    className={data?.culture === languageCulture.culture ? 'c-item-02-A active' : 'c-item-02-A'}>
                                                    {data?.cultureName}
                                                </a>
                                            ))}
                                        </div>
                                    </MenuItem> */}
                                    <a
                                        href="#!"
                                        className="c-item-userInfo"
                                        onClick={async (e: any) => {
                                            e.preventDefault();
                                            window.localStorage.clear();
                                            history.push('/accounts/logout');
                                        }}>
                                        <MenuItem>
                                            <ExitToAppIcon></ExitToAppIcon>
                                            <span className="c-item-01-A">{words && words['WEB.exit']}</span>
                                        </MenuItem>
                                    </a>
                                </Menu>
                            </div>
                        </div>
                    )}
                </div>
                <div className="c-item-03">
                    <img src="https://khicindekocvar.blob.core.windows.net/prod/KocLogo.png" alt="koclogo" />
                </div>
            </div>
        </div>
    );
};

export default Header;
